import { useContext, useState } from "react";
import { MobileContext } from "../../providers/MobileContext";
import Layout from "../../Components/Layout/Layout";
import Label from "../../Components/Input/Label";
import Input from "../../Components/Input/Input";
import Textarea from "../../Components/Input/Textarea";
import BasicAPI from "../../API/BasicAPI";
import Wrapper from "../../Components/Layout/Wrapper";
import Form from "../../Components/Form/Form";
import { useNavigate } from "react-router-dom";
import { CheckEmail } from "../../Validation/Validations";

const ContactPage = () => {
  const navigate = useNavigate();
  const isMobile = useContext(MobileContext);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    title: "",
    message: "",
  });

  const onChangeInput = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submitForm = () => {
    if (formData.name === "") {
      alert("이름을 입력해주세요.");
      return;
    }
    if (formData.email === "") {
      alert("이메일을 입력해주세요.");
      return;
    }
    if (formData.title === "") {
      alert("문의 제목을 입력해주세요.");
      return;
    }
    if (formData.message === "") {
      alert("문의 내용을 입력해주세요.");
      return;
    }
    if (!CheckEmail(formData.email)) {
      alert("유효한 이메일 주소를 입력해주세요.");
      return;
    }

    BasicAPI({
      url: `${process.env.REACT_APP_SERVICE_URL}/partner/contact/`,
      method: "POST",
      data: formData,
      success: (res) => {
        alert(res.message);
        navigate("/");
      },
      fail: (res) => console.error(res),
    });
  };

  return (
    <Layout>
      <div
        style={{
          backgroundColor: isMobile ? "white" : "#f7f8fb",
        }}
      >
        <Wrapper>
          <Form title="문의하기" btnText="작성 완료" onClick={submitForm}>
            <div>
              <Label label="이름" />
              <Input
                name="name"
                value={formData.name}
                onChange={onChangeInput}
                placeholder="이름을 입력해주세요"
              />
            </div>
            <div>
              <Label label="이메일" />
              <Input
                name="email"
                value={formData.email}
                onChange={onChangeInput}
                placeholder="이메일을 입력해주세요"
              />
            </div>
            <div>
              <Label label="문의내용" />
              <Input
                name="title"
                value={formData.title}
                onChange={onChangeInput}
                placeholder="문의 제목"
              />
              <Textarea
                name="message"
                value={formData.message}
                onChange={onChangeInput}
                rows="10"
                placeholder="내용을 입력해주세요"
              />
            </div>
          </Form>
        </Wrapper>
      </div>
    </Layout>
  );
};

export default ContactPage;
